export default __webpack_public_path__ + "images/appicon.png";